<!-- 航班详情 -->
<template>
  <div class="backgroundGrey base-padding">
    <div class="details-card">
      <div class="details-title">
        航班信息
      </div>
      <div class="detailsItem">
        <div>
          <span>航班日期：</span>
          <span>{{ main.flightDate }}</span>
        </div>
        <div>
          <span>航线环：</span>
          <span>{{ main.flightNoRing }}</span>
        </div>
        <div>
          <span>航段环：</span>
          <span>{{ main.flightLineRing }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="details-card">
      <div class="details-title">
        主配单
      </div>
      <Grid :columns="columns" :tableData="tableData" />
    </div> -->
    <div class="details-card" v-for="(item,index) in applies" :key="index">
      <div class="details-title">
        加配单
        <span style="float:right;">{{ item.applyNo }}</span>
      </div>
      <Grid :columns="columns" :tableData="item.details" />
    </div>
    <BottomButton v-if="!applies || !applies.length">
      <van-button type="primary" @click="addApplication">加配申请</van-button>
    </BottomButton>
  </div>

</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'
import Grid from '@/components/common/Grid/index.vue'
import BottomButton from '@/components/common/BottomButton'

export default {
  components: {
    EmptyTips,
    Grid,
    BottomButton,
  },
  data() {
    return {
      main: {},
      columns: [
        { label: '商品名称', prop: 'productName' },
        { label: '规格', prop: 'sku' },
        { label: '售价', prop: 'price' },
        { label: '配货数量', prop: 'quantity' },
      ],
      applies: [],
    }
  },
  activated() {
    this.main = this.$route.query
    this.getAllByDateAndNo()
  },
  methods: {
    addApplication() {
      this.$utils.routerPush({
        name: 'SelectProduct',
        query: this.main,
        params: { clearData: true },
      })
    },
    // 获取详情
    getAllByDateAndNo() {
      let params = {
        staffId: this.$store.state.userInfo.userId,
        companyId: this.$store.state.userInfo.companyId,
        ...this.main,
      }
      this.$api.post('/api-sys/sell/addMatterSearch/getAllByDateAndNo', params).then((res) => {
        this.applies = res.data.applies
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/view/DistributionApplication/FlightDetails.vue